import { Injectable } from '@angular/core';
import { MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { NavigationExtras, Router } from '@angular/router';
import { AnalyticsService, DialogService, OrdersService } from '@box-core/services';
import { Order, GAItemRatingConfig } from '@box-types';
import { ReviewDialogComponent } from '@box-rating-widget/components';
import { ReviewDialogData } from '@box-rating-widget/components/review-dialog/review-dialog.types';
import { Observable, BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class AccountHistoryOrdersService {
  private readonly ordersSource = new BehaviorSubject<Order[]>([]);
  public readonly orders$ = this.ordersSource.asObservable();

  constructor(
    private router: Router,
    private dialogService: DialogService,
    private ordersService: OrdersService,
    private analyticsService: AnalyticsService
  ) {}

  public setOrders(orders: Order[]): void {
    this.ordersSource.next(orders);
  }

  public getOrders$(): Observable<Order[]> {
    return this.ordersService
      .getOrderHistory$()
      .pipe(map((orders) => orders.map((order) => this.ordersService.orderDecorator(order))));
  }

  public handleOrderRateShop(order: Order, rating: number): MatDialogRef<ReviewDialogComponent> {
    this.triggerAnalyticsRatingEvent(rating);
    const dialogConfig: MatDialogConfig<ReviewDialogData> = {
      panelClass: 'box-dialog',
      ariaLabel: 'tell_us_your_opinion_title',

      disableClose: true,
      data: { order, rating, source: 'history' }
    };
    return this.dialogService.openDialog(ReviewDialogComponent, dialogConfig);
  }

  public handleOrderSelection(order: Order): void {
    if (!order) return;
    const options: NavigationExtras = { queryParams: { friendlyId: order.friendlyId } };
    return void this.router.navigate(['/checkout', 'order-status'], options);
  }

  public updateOrderHistoryAfterRate(order: Order, rating: number): void {
    this.ordersService.updateOrderHistoryAfterRate(order, rating);
  }

  private triggerAnalyticsRatingEvent(rating: number): void {
    const gaConfig = {
      rating: String(rating),
      source: 'history'
    } as GAItemRatingConfig;
    this.analyticsService.addGACustomEvent('item_rating', gaConfig);
  }
}
